export const FILTER_DRAWER_FOOTER_TEXTS = {
    SAVE: 'Save filter',
    CLEAR: 'Clear filters',
};

export const FILTER_DRAWER_FOOTER_TEST_ID = {
    SAVE: 'campaigns-filter-save',
    CLEAR: 'campaigns-filter-clear',
};

export const FILTER_DRAWER_FOOTER_AUTO_TEST_ID = {
    SAVE: 'campaigns-filter-save',
    CLEAR: 'campaigns-filter-clear',
};
